import { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ProductStyles from "../../../../OBJRep/ProductStyles";
import EncarteProduct from "../../../sharable/EncarteProduct/EncarteProduct";
import { Selector } from "../../../sharable/PickerAndSelector";
import {
  BrandLogo,
  calcProductStylesOcurrence,
} from "../../CanvasViewer/Canvas/CanvasGeneralStyles";
import { isCartazFormat } from "../../../../services/Utils";
import {
  ROUND_LOGO_WITH_BORDER,
  SQUARE_LOGO_WITH_BORDER,
} from "../../CanvasViewer/EncarteConstants";
import useFormatFontFamily from "./useFormatFontFamily";
import WorkspaceContext from "../../WorkspaceContext";
import { MenuDescription, MenuTitle } from "../Toolbar";
import PricesMenuView from "./PricesMenuView";
import ProductLayout from "./ProductLayout";
import {
  Container,
  FontSizeSlider,
  FontSizeSliderWrapper,
  LogoStyle,
  LogoStyleList,
  SelectedProductPreview,
  SelectProductWrapper,
  Styles,
} from "./StylesMenuView.styles";
import TextStylesWrapper from "./TextStylesWrapper";
import useFormatFooterStyles from "./useFormatFooterStyles";

export default function StylesView() {
  const [selectedProduct, setSelectedProduct] = useState();
  const [productStyles, setProductStyles] = useState(ProductStyles());
  const {
    styles,
    products,
    onProductsChange,
    onStylesChange,
    userBrand,
    canvasScale,
    canvasSelectedProductIndex,
  } = useContext(WorkspaceContext);
  const updatedProductStylesWithMostUsedStyles = useEffect(() => {
    /*update default styles with most used product styles */
    const colors = calcProductStylesOcurrence(products);
    setProductStyles(colors);
  }, [products]);

  useEffect(() => {
    if (canvasSelectedProductIndex !== null) {
      setSelectedProduct(products[canvasSelectedProductIndex]);
    } else {
      setSelectedProduct(undefined);
    }
  }, [canvasSelectedProductIndex]);

  useEffect(() => {
    if (selectedProduct && selectedProduct.styles) {
      setProductStyles(selectedProduct.styles);
    } else setProductStyles(calcProductStylesOcurrence(products));
  }, [selectedProduct]);

  const {
    footerOptions,
    selectedFooterStyle,
    getFooterStyleValueByLabel,
    isFooterStylePremiumByLabel,
  } = useFormatFooterStyles(styles, onStylesChange);
  const hideNonFooterStyles = isCartazFormat(styles.format);
  const { fontFamilies } = useFormatFontFamily(styles, onStylesChange);
  const updateProductStyle = (style, value) => {
    if (selectedProduct) {
      const selectedProductCopy = { ...selectedProduct };
      selectedProductCopy.styles[style] = value;
      let productsCopy = [...products];
      productsCopy = productsCopy.map((p, i) => {
        if (p.id === selectedProduct.id) {
          p = selectedProductCopy;
        }
        return p;
      });
      setProductStyles(selectedProductCopy.styles);
      setSelectedProduct(selectedProductCopy);

      onProductsChange(productsCopy);
    } else {
      const s = { ...productStyles };
      s[style] = value;
      setProductStyles(s);
      const updatedProducts = products.slice().map((p) => {
        p.styles[style] = value;
        return p;
      });
      onProductsChange([...updatedProducts]);
    }
  };
  const handleLogoUpdate = (e) => {
    if (!e.target.classList.contains("logo")) return;
    const wrapper = e.target.closest(".logos-wrapper");
    wrapper.querySelectorAll(".logo").forEach((n) => {
      n.classList.remove("selected");
    });
    e.target.classList.add("selected");
  };

  return (
    <Container>
      <MenuDescription>
        Estilize o encarte da maneira que preferir. Altere cores de fundo e de
        texto, e escolha dentre as fontes disponiveis.
      </MenuDescription>
      {!hideNonFooterStyles && (
        <SelectProductWrapper>
          {selectedProduct != undefined ? (
            <>
              <SelectedProductPreview>
                <EncarteProduct
                  product={selectedProduct}
                  canvasScale={canvasScale}
                  styles={styles}
                />
              </SelectedProductPreview>
              <span className="preview">Editando {selectedProduct.name}</span>
            </>
          ) : (
            <span></span>
          )}
        </SelectProductWrapper>
      )}
      <MenuTitle>estilo do encarte</MenuTitle>
      <Styles className="flex direction-column">
        {!hideNonFooterStyles && (
          <>
            <TextStylesWrapper
              onStylesChange={onStylesChange}
              selectedProduct={selectedProduct}
              styles={styles}
              updateProductStyle={updateProductStyle}
              productStyles={productStyles}
            />
            {selectedProduct && (
              <FontSizeSliderWrapper className="flex direction-column">
                <label htmlFor="image-crop-slider">
                  Zoom da imagem:{" "}
                  <strong>{productStyles.imageZoom || 0}%</strong>
                </label>
                <FontSizeSlider
                  id="image-crop-slider"
                  type="range"
                  min={100}
                  max={150}
                  value={productStyles.imageZoom || 0}
                  onChange={(e) =>
                    updateProductStyle("imageZoom", Number(e.target.value))
                  }
                />
              </FontSizeSliderWrapper>
            )}

            {selectedProduct && (
              <ProductLayout
                selectedProduct={selectedProduct}
                updateProductStyle={updateProductStyle}
              />
            )}
            <PricesMenuView
              updateProductStyle={updateProductStyle}
              selectedProduct={selectedProduct}
            />
            {!selectedProduct && (
              <LogoStyle>
                <h2>Logo</h2>
                <LogoStyleList
                  className="logo-style-wrapper"
                  onClick={handleLogoUpdate}
                >
                  <LogoStyleComponent
                    logo={userBrand.logoURLTmp}
                    text="redonda com borda"
                    componentLogoStyle={ROUND_LOGO_WITH_BORDER}
                    encarteLogoStyle={styles.logoStyle}
                    onStylesChange={onStylesChange}
                    defaultLogoStyle={true}
                    encarteStyles={styles}
                  />

                  <LogoStyleComponent
                    logo={userBrand.logoURLTmp}
                    text="Quadrada com borda"
                    componentLogoStyle={SQUARE_LOGO_WITH_BORDER}
                    encarteLogoStyle={styles.logoStyle}
                    onStylesChange={onStylesChange}
                    encarteStyles={styles}
                  />
                </LogoStyleList>
              </LogoStyle>
            )}
          </>
        )}
        <div>
          <h2 style={{ marginBottom: "15px" }}>Texto</h2>
          <Selector
            options={fontFamilies}
            txt="Estilo da fonte"
            callback={(c) => {
              onStylesChange("fontFamily", c);
            }}
            selected={styles.fontFamily}
          />
        </div>
        <div>
          <h2 style={{ marginBottom: "15px" }}>Rodapé</h2>
          <Selector
            txt={""}
            options={footerOptions}
            selected={selectedFooterStyle?.label}
            callback={(c) =>
              onStylesChange("footerStyle", getFooterStyleValueByLabel(c))
            }
            isPremiumOption={(option) => isFooterStylePremiumByLabel(option)}
          />
        </div>
      </Styles>
    </Container>
  );
}

const LogoStyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: min-content;
  height: min-content;

  span {
    margin-top: 1rem;
    font-size: 1.4rem;
    text-align: center;
    &::first-letter {
      text-transform: uppercase;
    }
  }
`;
const LogoImage = styled(BrandLogo)`
  border: 0px solid transparent;
  width: 80px;
  height: 80px;
  position: relative;
  &:hover {
    border-color: #d97706;
    border-width: 4px;
  }

  ${({ encarteLogoStyle, componentLogoStyle, defaultLogoStyle }) => {
    const isCurrentLogoStyle =
      encarteLogoStyle === componentLogoStyle ||
      (!encarteLogoStyle && defaultLogoStyle)
        ? true
        : false;

    return css`
      ${isCurrentLogoStyle && "border-color: #d97706; border-width: 4px;"}
    `;
  }}
`;

const LogoStyleComponent = ({
  logo,
  text,
  encarteLogoStyle,
  componentLogoStyle,
  defaultLogoStyle = false,
  onStylesChange,
  encarteStyles,
}) => {
  return (
    <LogoStyleWrapper className="wrapper flex direction-column">
      <LogoImage
        logoStyle={componentLogoStyle}
        encarteLogoStyle={encarteLogoStyle}
        defaultLogoStyle={defaultLogoStyle}
        encarteStyles={encarteStyles}
        logo={logo}
        onClick={() => {
          onStylesChange("logoStyle", componentLogoStyle);
        }}
      />
      <span>{text}</span>
    </LogoStyleWrapper>
  );
};
